


























































































import CtrlSearchCommonComponents from '@/components/common/control/CtrlSearchCommonComponents.vue';
import Vue from 'vue';
import moment from 'moment';
import { mapGetters } from 'vuex';
import CtrlNormalTxt from '@/components/common/control/CtrlNormalTxt.vue';
import CtrlSoko from '@/components/common/search/CtrlSoko.vue';
import { API_SEARCH_ZAIKO } from '@/constants/api';

export default Vue.extend({
  name: 'ListZaiko',
  components: {
    CtrlSearchCommonComponents,
    CtrlNormalTxt,
    CtrlSoko,
  },
  props: {
    initialDataSearch: {
      type: Boolean,
      default: false,
    },
    jigyoshoCd: {
      type: Number,
      required: true,
    },
    sokoCd: {
      type: Number,
      required: true,
    },
    himmokuCd: {
      type: Number,
      required: true,
    },
    himmokuMei: {
      type: String,
      required: true,
    },
    getZaiko: {
      type: Function,
    },
    sokoHenkoFlg: {
      type: Boolean,
      default: true,
    },
    forReadonly: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    API_SEARCH_ZAIKO,
    sokoCdRef: 0,
    targetYmd: 0,
    headers: [
      {
        text: '倉庫',
        sortable: true,
        value: 'sokoRyakuMei',
        width: 287,
      },
      {
        text: '年産',
        sortable: true,
        value: 'nensan',
        width: 84,
      },
      {
        text: '賞味期限',
        sortable: true,
        value: 'shomiKigenYmdDisp',
        width: 117,
      },
      {
        class: 'text-end',
        cellClass: 'text-end',
        text: '在庫数',
        sortable: true,
        value: 'zaikoSu',
        width: 101,
      },
      {
        class: 'text-end',
        cellClass: 'text-end',
        text: '入庫予定',
        sortable: true,
        value: 'nyukoYotei',
        width: 118,
      },
      {
        class: 'text-end',
        cellClass: 'text-end',
        text: '出庫予定',
        sortable: true,
        value: 'shukkoYotei',
        width: 118,
      },
    ],
    formatColName: '',
    filterGroupKey: 0,
  }),
  computed: {
    ...mapGetters({
      userInfo: 'common/userInfo',
    }),
  },
  methods: {
    resetData() {
      this.sokoCdRef = this.sokoCd;
      // ログイン情報：現在日付
      this.targetYmd = this.userInfo.onlineData.genzaiYmd;
      // Increment to refresh form
      this.filterGroupKey += 1;
    },
    callbackCancel(ctrlName: string) {
      console.log(`callbackCancel --- ${ctrlName}`);
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    callbackZaikoOk(items: any) {
      this.getZaiko(items);
      this.$emit('update:show', false);
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    callbackSokoOk(item: any) {
      this.sokoCdRef = item.sokoCd;
    },
  },
  created() {
    this.resetData();
  },
});
